import { GetHoursByDay } from 'domain/usecases/scheduling/get-hours-by-day'
import { SchedulingRepository } from 'repository/interfaces/scheduling-repository'

export class RemoteGetHoursByDay implements GetHoursByDay {
  private readonly schedulingRepository: SchedulingRepository

  constructor(schedulingRepository: SchedulingRepository) {
    this.schedulingRepository = schedulingRepository
  }

  load(params: GetHoursByDay.Params): Promise<GetHoursByDay.Model> {
    return this.schedulingRepository.getHoursByDay(params)
  }
}

export type SearchDoctorsModel = GetHoursByDay.Model
